import { TenantService } from './../services/tenant.service';
import { AddEmptyTopicDialogComponent } from './addEmptyTopicDialog.component';
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { UtilService, RoutingHistoryService } from "../services";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as _ from 'lodash';
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { filter, tap } from 'rxjs/operators';

@Component({
    styles: [`
        .big-icon {
            font-size: 20px
        }

        mat-card.mat-card {
            min-width: 350px;
            min-height: 285px;
            width: 350px;
            height: 285px;
        }

        mat-card-content.mat-card-content {
            min-height: 168px;
        }
        
        .full-width {
            min-width: 100%;
        }      

        a {
            text-decoration: underline;
        }   
    `],
    template: `
        <div fxFlex fxLayout="column" fxLayoutAlign="center" [formGroup]="form">
            <div fxLayout="column">
                <div fxLayoutAlign="center center">
                    <h2>Create a topic</h2>
                </div>
                <div fxLayoutAlign="center center">
                    <p style="max-width: 550px">
                        Create topics that match specific interests or subjects. 
                        Name your topic and provide one or more keywords to get started.
                        <a color="primary" [routerLink]="['../starters']">See Examples</a>
                    </p>
                </div>
                <div fxLayoutAlign="center center">
                    <mat-form-field fxFlex="0 1 550px">
                        <input placeholder="Topic Name" matInput formControlName="topicName" fxFlex>
                        <mat-error *ngIf="form.get('topicName').hasError('required')">Name is required.</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayoutAlign="center center">
                    <mat-form-field fxFlex="0 1 550px">
                        <mat-icon matPrefix style="padding-right: 10px;">search</mat-icon>
                        <input placeholder="Keywords" matInput formControlName="searchText" fxFlex>
                        <mat-error *ngIf="form.get('searchText').hasError('required')">Keywords are required.</mat-error>
                        <mat-hint>
                            For best results limit your keywords to the main concept you want in the topic.
                        </mat-hint>
                    </mat-form-field>
                </div>

                <div fxLayoutAlign="center center" style="padding-top: 15px;">
                    <p>
                        Results should: 
                        <mat-select placeholder="Match Type" 
                                    formControlName="matchType" 
                                    style="width: 185px; padding-left: 5px; padding-right: 40px;">
                            <mat-option value="IncludeAllKeywords">Include All Keywords</mat-option>
                            <mat-option value="IncludeAnyKeywords">Include Any Keywords</mat-option>
                            <mat-option value="MatchExactPhrase">Match Exact Phrase</mat-option>
                        </mat-select>
                    </p>
                </div>
                <div fxLayoutAlign="center center" style="padding-top: 15px;">
                    <span [matTooltip]="form.invalid ? 'Topic name required.' : 'Start'">
                        <button mat-raised-button color="primary" (click)="search()" [disabled]="form.invalid">Start</button>
                    </span>
                </div>
                <div fxLayoutAlign="center center" style="padding-top: 30px;">
                    <a mat-button 
                       (click)="addSimple()" 
                       color="primary" 
                       style="cursor: pointer; font-size: 17px;">Skip and create an empty topic</a>
                </div>
                <div fxLayoutAlign="center center" style="padding-top: 30px;">
                    <a mat-button 
                       color="primary" 
                       target="_blank"
                       href="https://attensa.com/topicfaq/" 
                       style="cursor: pointer; font-size: 17px;">Topic FAQ and videos</a>
                </div>
            </div>
        </div>
    `
})
export class StartCreateTopicComponent {
    form: FormGroup;
    showAdvanced: boolean;

    constructor(fb: FormBuilder,
                private dialog: MatDialog,
                public snackBar: MatSnackBar,
                private router: Router,
                private routingHistoryService: RoutingHistoryService,
                tenantService: TenantService,
                private utilService: UtilService) {
        tenantService.getUnauthTenantInfo()
            .subscribe(tenant => this.showAdvanced = tenant.settings.showManuallySelectSources === 'true');
        
        this.form = fb.group({ 
            topicName: ['', Validators.required],
            searchText: ['', Validators.required],
            matchType: ['IncludeAllKeywords'] 
        });
    }

    search(): void {
        this.router.navigate(['/topics', 'builder'], { queryParams: { 
            name: this.form.get('topicName').value.trim(),
            term: this.utilService.cleanQuotes(this.form.get('searchText').value.trim()),
            matchType: this.form.get('matchType').value 
        } });
    }

    addSimple(): void {
        this.dialog.open(AddEmptyTopicDialogComponent, { data: { topicName: this.form.getRawValue().topicName } }).afterClosed()
        .pipe(
            filter(res => !!res),
            tap(topicId => this.routingHistoryService.injectSyntheticHistoryItem(`/browse/categories/uncategorized/topics/${topicId}/content/sources`))
        ).subscribe(topicId => this.router.navigate(['/topics', topicId, 'content', 'sources']));
    }
}
